import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { SearchCustomerParam } from 'src/app/Models/searchCustomer';
import { TransactionService } from '../../../Services/transaction.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from 'src/app/Services/notification.service';

@Component({
  selector: 'app-spra-salesadminreview-list',
  templateUrl: './spra-salesadminreview-list.component.html',
  styleUrls: ['./spra-salesadminreview-list.component.css']
})
export class SpraSalesadminreviewListComponent implements OnInit {
  EmployeeId:number=0;
  private utility: Utility  
  public ValidationListAdminsalesHeader: String[] = ["requestNo","saleCode","partyName", "productCategory", "saleType", "lastValidatedBy","validatedate","isRental"];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public IsCeha:boolean;
  constructor(private _TransactionService: TransactionService
    , private intl: MatPaginatorIntl
    , private changeDectector: ChangeDetectorRef
    , private router: Router
    , private route: ActivatedRoute
    , private cookieService: CookieService
    , private _NotificationService:NotificationService) {

      this.utility = new Utility(this.cookieService);
      this.sort = new MatSort();
      this.paginator = new MatPaginator(this.intl, this.changeDectector);
      this.IsCeha = false;
      this.route.params.subscribe( (params) =>{
        if(params.IsCeha != undefined && params.IsCeha ==1){
          this.IsCeha = true;
        }
      });
  
      let param: any = this.router.getCurrentNavigation()?.extras.state;
      if (param) {     
        if (param.Message){
          this._NotificationService.showSuccess(param.Message,"");
        }
         }
     }

  ngOnInit(): void {
        // this.EmployeeId=this.utility.user.employeeId;
        this._TransactionService.GetReviewListForAdminSales(this.IsCeha).subscribe((d: any) => {
          this.dataSource.data = d;
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });
        }, (error) => {                              //Error callback
          this.utility.Error(error);
        });
  }
  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  public doFilter = (event: any) => {
    this.dataSource.filter = event.target.value.trim().toLocaleLowerCase();
  }
  onRequestClick(row :any) {
    let page:string = "spra-request"
    if(row.isRental){
      page = "spra-rental-request";
    }


    this.router.navigate([page], {
      state: {
        "SPRAId": row.id,
        "UpdateTag": "U",
        "IsSalesAdmin":true,
        "RefId": row.refId,
        "SaleCode": row.saleCode,
        "OfficeId": row.officeID  ,
        "SaleType": row.saleType,
        "CompanyId": row.companyID,
        "PartnerId": row.partnerId,
        "IsCeha":this.IsCeha, //Added by rahul yadav on 7/6/2021 in case of 
        "IsFromApprovedlist":true //Added by rahul yadav on 10/05/2022 in case of
      }
    });

  }
}
